import axiosInstance from "app/axiosInstance";
import { MapViewPreferences } from "../types/mapPreferences.types";

/**
 * Future API contract (not yet available on backend):
 * - GET  /users/{userId}/accounts/{accountId}/map-preferences
 * - PUT  /users/{userId}/accounts/{accountId}/map-preferences
 */
class MapPreferencesService {
  static getMapPreferences = async (userId: string, accountId: string) => {
    return axiosInstance.get(
      `/users/${encodeURIComponent(userId)}/accounts/${encodeURIComponent(accountId)}/map-preferences`
    );
  };

  static saveMapPreferences = async (
    userId: string,
    accountId: string,
    data: MapViewPreferences
  ) => {
    return axiosInstance.put(
      `/users/${encodeURIComponent(userId)}/accounts/${encodeURIComponent(accountId)}/map-preferences`,
      data
    );
  };
}

export default MapPreferencesService;
